import type { RouteType } from "ui-kit";
import { lazy } from "ui-kit";

import { paths } from "../paths/assets";

export const routes: RouteType[] = [
  {
    path: paths.listAll,
    component: lazy(() => import("../pages/assets/List/AllGroups")),
  },
  {
    path: paths.list,
    component: lazy(() => import("../pages/assets/List")),
  },
  {
    path: paths.bulkUpsert,
    component: lazy(() => import("../pages/assets/BulkUpsert")),
  },
  {
    path: paths.create,
    component: lazy(() => import("../pages/assets/Create")),
  },
  {
    path: paths.edit,
    component: lazy(() => import("../pages/assets/Edit")),
  },
  {
    path: paths.view,
    component: lazy(() => import("../pages/assets/View")),
  },
];
